module.exports = __webpack_public_path__ + "static/media/matilde-special-adventour-normal.031ee6fc.png";